import {
  AcAppHeader,
  AcTab,
  AcTabs,
} from '@components'
import { KEYS, LABELS, ROUTE_PATHS, TAG_DETAIL_TABS } from '@constants'
import { useStore } from '@hooks/use-store'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { ITagInformationTab } from '@partials/tabs/tag-detail/tag-information'
import { ITagRelatedProductsTab } from '@partials/tabs/tag-detail/tag-related-products'
import { ITagTargetedProductsTab } from '@partials/tabs/tag-detail/tag-targeted-products'
import { ITagRelatedCustomersTab } from '@partials/tabs/tag-detail/tag-related-customers'

export const AcProductTagDetail = observer((): JSX.Element => {
  const { tags, products, customer } = useStore()
  const { id } = useParams()

  useEffect(() => {
    if (id) {
      const tagId = parseInt(id)
      tags.getById(tagId)
    }

    return () => {
      tags.clearSingle()
    }
  }, [id])

  return (
    <>
      <AcAppHeader
        showBackButton
        navigateBackTo={ROUTE_PATHS.PRODUCT_TAGS}
        title={tags.single?.name || LABELS.TAG_DETAIL}
      />
      <AcTabs tabs={TAG_DETAIL_TABS}>
        <AcTab<ITagInformationTab> name={KEYS.TAG_INFORMATION} />
        <AcTab<ITagRelatedProductsTab> name={KEYS.TAG_RELATED_PRODUCTS} />
        <AcTab<ITagTargetedProductsTab> name={KEYS.TAG_TARGETED_PRODUCTS} />
        <AcTab<ITagRelatedCustomersTab> name={KEYS.TAG_RELATED_CUSTOMERS} />
      </AcTabs>
    </>
  )
})
